import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const StockTransferNoteView = () => {
 
 useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("STN Inward", "view");
            const canEntry = hasPermission("STN Inward", "entry");
           
           
            /////////////////////////////////////////////////////////////
       

  useEffect(() => {
    fetchData();
  }, [ branch ]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stnInward_list", {
        params: { branch: branch }
      });
      setData(response.data.purchaseOrderList);
      setFilteredData(response.data.purchaseOrderList);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

 const handleDisapprove = async (sfIssuesHeader_number, branch) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to disapprove this Request?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Disapprove!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/stnInward_reject", {
        sfIssuesHeader_number,
        branch
      });

      console.log("Response:", response.data);

      if (response.data.success) {
        Swal.fire("Disapproved!", "Request Disapproved!", "success").then(() => {
          // ✅ Call your data fetch function here
          fetchData(); // <--- Replace this with your actual fetch function name
        });
      } else {
        Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
      }
    } catch (error) {
      console.error("Error disapproving bill:", error);
      Swal.fire("Error!", "Error processing disapproval.", "error");
    }
  }
};
 

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.sfIssuesHeader_number || "").toLowerCase().includes(term) ||
       String(item.branchCode || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  

 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Stock Transfer Note - Pending View</h2>
          <Time />
        </section>




        

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by STN No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>STN No</th>
                <th>Date</th>
                <th>Stock Arrive From Branch</th>
                {canEntry && (
                  <>
                <th>Inward</th>
                <th>Reject</th>
                </>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/stnViewpendingSingle/${item.sfIssuesHeader_number}/${item.branchCode}`}>
                        {item.sfIssuesHeader_number}
                      </Link>
                    </td>
                    <td>{new Date(item.sfIssuesHeader_date).toLocaleDateString()}</td>
                    <td>{item.branchCode}</td>
                    {canEntry && (
                      <>
                    <td>
                      <Link to={`/inventory/stnInward/${item.sfIssuesHeader_number}/${item.branchCode}`}>
                        Inward
                      </Link>
                    </td>
                <td
  style={{
    color: '#dc3545',
    cursor: 'pointer',
    padding: '8px',
    fontWeight: 'bold'
    // border: '1px solid #dee2e6'
  }}
  onClick={() => handleDisapprove(item.sfIssuesHeader_number, item.branchCode)}
>
  Reject
</td>
</>
                    )}

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockTransferNoteView;
 